import React, { useState } from "react";
import "aos/dist/aos.css";
import { HiArrowSmRight } from "react-icons/hi";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import Slider from "react-slick";
import { API_BASE_URL } from "../config";
import { useEffect } from "react";

const NewsAndEvents = () => {
	const [slidesData, setSlidesData] = useState([]);
	const [toggleSwitch, setToggleSwitch] = React.useState({});
	const [loading, setLoading] = useState(false);
	const getHeadingActivity = async () => {
		try {
			const response = await axios.get(`${API_BASE_URL}/getactivityData`);
			const fetchedData = response.data.data;
			const initialSwitchState = {};
			fetchedData.forEach((slide) => {
				initialSwitchState[slide.id] = slide.Published;
			});
			setSlidesData(response?.data?.data);
			if (response?.data?.data) {
				setLoading(true);
				response.data.data.reduce((prev, slide) => {
					return { ...prev, [slide.id]: slide.Photo };
				}, {});
			}
			setToggleSwitch(initialSwitchState);
		} catch (e) {
			console.log("err", e);
		}
	};
	useEffect(() => {
		getHeadingActivity();
	}, []);

	const returnIndex = (id) => {
		const index = slidesData.findIndex((slide) => slide.id === id);
		return index;
	};

	const [isModalOpen, setModalOpen] = useState(false);
	const [getDataId, setDataId] = useState();
	const getPopUpData = (id) => {
		setModalOpen(true);
		setDataId(id);
	};
	const settings = {
		dots: true,
		infinite: true,
		speed: 600,
		slidesToShow: 2,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		responsive: [
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	};

	return (
		<>
			{!loading && (
				<div className="fixed inset-0 top-1/2 left-1/2">
					<div role="status">
						<svg
							aria-hidden="true"
							class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
							viewBox="0 0 100 101"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
								fill="currentColor"
							/>
							<path
								d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
								fill="currentFill"
							/>
						</svg>
						<span class="sr-only">Loading...</span>
					</div>
				</div>
			)}
			<div className="bg-[#1A2338] ">
				<h1 className="text-white px-[25px] lg:pt-[24px] pt-[20px] py-2 lg:py-0 font-['Roboto'] font-bold lg:text-4xl text-2xl text-center ">
					News and Events
				</h1>

				<Slider
					{...settings}
					className="font-['Roboto'] w-screen flex flex-col md:flex-row"
				>
					{slidesData &&
						slidesData.map((slide, index) => {
							return (
								<>
									{toggleSwitch[slide?.id] && (
										<div className="mx-4 my-4 lg:flex lg:flex-row lg:justify-around">
											<div className="flex flex-col lg:mb-[3rem] lg:flex-row mb-[1rem] 2xl:mx-[50px] space-y-5">
												<div className="lg:mt-[29px] lg:ml-[1.5rem] lg:w-[18rem] lg:h-[10rem] 2xl:w-[22rem]">
													<img
														src={slide?.Photo}
														alt="image1"
														className="w-screen rounded-2xl"
													/>
												</div>
												<div className="lg:mt-[29px] space-y-6 py-4 lg:py-0 rounded-lg px-6">
													<h1 className="text-2xl font-semibold lg:w-[15rem] 2xl:w-[20rem] text-white lg:text 2xl">
														{slide?.Heading}
														<p
															style={{ fontFamily: "Lato, sans-serif" }}
															className="mt-[8px] lg:w-[15rem] 2xl:w-[15rem]   font-normal text-sm lg:text-base text-white"
														>
															{slide?.Description &&
															slide.Description.length > 100
																? slide.Description.slice(0, 100) + "..."
																: slide?.Description}
														</p>
													</h1>
													<div
														className="cursor-pointer text-[#878787] font-normal text-sm flex items-center group"
														style={{ lineHeight: "28px" }}
														onClick={() => getPopUpData(slide?.id)}
													>
														<span className="border-b-2 border-[#878787]">
															Read More
														</span>
														<HiArrowSmRight className="w-6 h-8 ml-2" />{" "}
													</div>
												</div>
											</div>
										</div>
									)}
								</>
							);
						})}
				</Slider>
			</div>
			<>
				{isModalOpen && (
					<div className="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-full overflow-y-scroll bg-black bg-opacity-50">
						<div
							className="bg-white rounded-lg lg:p-5 lg:w-[1187px] lg:h-[600px] overflow-y-scroll"
							style={{
								top: "671px",
								left: "127px",
								borderRadius: "16px",
							}}
						>
							<div className="flex flex-col">
								<div class="flex justify-end items-center">
									<img
										className="w-[3rem] h-[3rem] lg:mt-0 mt-[1rem]"
										src="/logo.png"
										alt="Logo"
									/>
								</div>
								<div className="flex flex-col lg:flex-row lg:space-x-8">
									<div className="flex justify-center">
										<img
											className="w-full w-5/6 lg:h-[10rem] lg:ml-[4rem] lg:mt-[2rem]  rounded-2xl"
											src={slidesData[returnIndex(getDataId)]?.Photo}
											alt="images"
										/>
									</div>
									<div>
										<h1
											className="lg:ml-[4rem] ml-[1rem] lg:mt-[2rem] font-bold lg:text-4xl text-md text-[#1A2338]"
											style={{ lineHeight: "50px" }}
										>
											{slidesData[returnIndex(getDataId)]?.Heading}
										</h1>
									</div>
								</div>
								<div>
									<p
										style={{
											fontFamily: "Lato, sans-serif",
											lineHeight: "30px",
										}}
										className="mx-10 lg:mx-0 lg:ml-[4.5rem] ml-[1rem] lg:mt-[2.9rem] font-normal lg:text-2xl text-lg text-[#1A2338]"
									>
										{slidesData[returnIndex(getDataId)]?.Description}
									</p>
								</div>
							</div>
							<button
								className="lg:mt-[61px]  ml-[1rem] mb-[2rem] lg:mb-[48px] px-[20px] py-[10px] mt-[0.5rem] lg:px-[50px] lg:py-[10px] lg:ml-[29rem] rounded-xl bg-[#1A2338] text-white "
								onClick={() => setModalOpen(false)}
							>
								Close
							</button>
						</div>
					</div>
				)}
			</>
		</>
	);
};

export default NewsAndEvents;
